import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, Stamp } from "lucide-react";
import { getPassport, ART_FORMS } from "../../data/artForms";

export default function StudioShell({ children, currentFormId }) {
  const [passport, setPassport] = useState(getPassport());
  const location = useLocation();

  useEffect(() => {
    const handler = () => setPassport(getPassport());
    window.addEventListener("passport-update", handler);
    return () => window.removeEventListener("passport-update", handler);
    // Mount-only: setPassport is stable; handler reads getPassport at fire time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stampedCount = Object.keys(passport).length;
  const total = ART_FORMS.length;

  return (
    <div className="min-h-screen bg-[#F9F6F0] paper-grain">
      <header className="sticky top-0 z-40 bg-[#F9F6F0]/90 backdrop-blur-xl border-b border-[#E5DFD3]">
        <div className="max-w-6xl mx-auto px-6 sm:px-10 py-4 flex items-center justify-between gap-4">
          <Link
            to={location.pathname === "/studio" ? "/" : "/studio"}
            data-testid="studio-back"
            className="inline-flex items-center gap-2 text-sm text-[#1E2A4F] hover:text-[#D95D39] transition-colors"
          >
            <ArrowLeft size={16} />
            <span className="hidden sm:inline">
              {location.pathname === "/studio" ? "Back to Divya's Story World" : "All art forms"}
            </span>
            <span className="sm:hidden">Back</span>
          </Link>
          <p className="font-display text-base sm:text-xl text-[#1E2A4F]">
            Meera&apos;s <em className="italic font-light">Art Studio</em>
          </p>
          <Link
            to="/studio#passport"
            data-testid="studio-passport-pill"
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#1E2A4F] text-[#F9F6F0] text-xs"
          >
            <Stamp size={14} />
            <span>
              {stampedCount}/{total}
            </span>
          </Link>
        </div>
      </header>
      {children}
    </div>
  );
}
